import { actionCreators as tasksLogsActionCreators } from "Areas/SharedFeatures/tasksLogs";
import { connect } from "react-redux";
import api from "./redux/api";
import TasksTable from "./tasksTable";
const mapStateToProps = (_, ownProps) => ({
    loadUrl: ownProps.projectId
        ? api.getProjectTasks(ownProps.projectId)
        : ownProps.workspaceId
            ? api.getWorkspaceTasks(ownProps.workspaceId)
            : undefined
});
const mapDispatchToProps = (dispatch) => ({
    onTaskLogOpen: (show, sourceTaskIds, title) => dispatch(tasksLogsActionCreators.toggleTasksLogsResult(show, sourceTaskIds, title))
});
export default connect(mapStateToProps, mapDispatchToProps)(TasksTable);
